<form [formGroup]="formGroup" novalidate>
  <nsc-card>
    <nsc-card-title note="All fields required, unless otherwise indicated">Sign Consent Form</nsc-card-title>
    <nsc-card-content>
      <div class="mat-typography">
        <p>
          A signed consent form is required to release your transcript. If we do not receive your consent form within 30 calendar days from the date you submit your request, your order will be canceled, and you will not be charged.
        </p>

        <hr class="nsc-hr" style="margin-top:5px; margin-bottom:5px">

        <p>
          <strong>Requestor:</strong> {{ content.requestor }}<br>
          <strong>Order Number:</strong> {{ content.orderId }}
        </p>

        <div class="mat-typography">
          <strong>Transcript Recipient(s)</strong>
          <div class="mat-typography" *ngFor="let recipient of content.recipients">
            {{ recipient.organization }}
          </div>
        </div>
      </div>
    </nsc-card-content>
  </nsc-card>

  <nsc-spacer size="md"></nsc-spacer>

  <nsc-card *ngIf="show.electronicConsentForm">
    <nsc-card-title>Electronic Consent Form</nsc-card-title>
    <nsc-card-content>
      <div class="mat-typography">
        <p>
          The fastest way to submit your consent form is electronically. Use your finger or mouse to draw your signature in the box. After you submit your signature, you may download a signed copy of the consent form for your records prior to providing payment in the next step.
        </p>

        <hr class="nsc-hr" style="margin-top:5px; margin-bottom:5px">

        <div class="reduce-top-margin"> 
          <strong tabindex="0" autofocus >Need Help Signing?</strong>
          <mat-icon
           role="img"
           tabindex="0"
           aria-hidden="false"
           aria-label="help about signature" 
           class="nsc-icon__align nsc-icon_info"
           (click)="openDialogue()">
            info
          </mat-icon>
        </div>

        <nsc-spacer size="lg"></nsc-spacer>

        <p class="mat-caption" [class.mat-error]="show.signatureError">
          <strong tabindex="0" autofocus>Sign Here</strong>

          <span *ngIf="show.signatureError">
            &ndash; The signature does not meet acceptable standards. Please clear and re-sign.
          </span>
        </p>

        <div class="row">
          <div class="col-12 col-md-10 col-lg-8">
            <div id="signature" autofocus (mouseenter)="hideWaterMark()" (mouseout)="isSignature()" (touchstart)="hideWaterMark()" (touchend)="isSignature()">
              <span class="nsc-watermark" *ngIf="isWaterMark">Sign Here</span>
              </div>
          </div>
        </div>

        <p class="nsc-margin-top">
          <strong>Signature Date:</strong> {{ values.signatureDate }}
        </p>
      </div>

      <hr class="nsc-hr" style="margin-top:5px; margin-bottom:5px">

      <div class="row">
        <div class="col-12 col-md-10 offset-md-1">
          <div class="mat-caption" style="text-align: center;">
            By submitting this signature, I, <strong>{{ content.requestor }}</strong>, certify that I am the above-named student and my electronic signature provided on this form is authentic and has the same validity and legally binding effect as signing this consent form by my hand in ink.
          </div>
        </div>
      </div>

      <nsc-spacer size="sm"></nsc-spacer>

      <div class="nsc-form-actions">
        <button
          mat-button
          id="orderconsent_clearsignature"
          class="nsc-button nsc-form-actions__button"
          type="button"
          (click)="clearSignature()"
          [disabled]="values.disableClearButton">Clear Signature</button>
        <nsc-spacer horizontal="true" size="sm"></nsc-spacer>
        <button
          mat-button
          id="orderconsent_acceptsignature"
          class="nsc-button nsc-form-actions__button"
          type="button"
          (click)="captureSignature()"
          [disabled]="values.disableAcceptButton">Accept Signature</button>
      </div>
    </nsc-card-content>
  </nsc-card>

  <div *ngIf="show.printableDefaultConsentForm">
    <nsc-spacer size="md"></nsc-spacer>
    <nsc-card>
      <nsc-card-title>Printable Consent Form</nsc-card-title>
      <nsc-card-content>
        <div class="mat-typography" tabindex="0">
         <p *ngIf="values.totalFees && values.totalFees > 0">You must <b>'Continue'</b> to the payment page after downloading the consent form to complete this order. If you do not continue to payment, your order will NOT be processed.</p>

         <p>If you would prefer to provide a signed paper copy, you may <a href="javascript:void(0)" (click)="captureDownload()">download a copy of the consent form</a> and either mail a copy to National Student Clearinghouse or provide a scanned copy in an e-mail attachment. Your order will be canceled if a consent form is not received within 30 days.</p> 
         <p class="nsc-note"><b>Note:</b> When downloading the consent form with an iPhone or iPad turn off your pop-up blocker first under your Safari settings.</p>
        </div>
      </nsc-card-content>
    </nsc-card>
  </div>

  <div *ngIf="show.printablePaperOnlyConsentForm">
    <nsc-spacer size="md"></nsc-spacer>
    <nsc-card>
      <nsc-card-title>Printable Consent Form</nsc-card-title>
      <nsc-card-content>
        <div class="mat-typography">
          <a href="javascript:void(0)" (click)="captureDownload()">Download the consent form</a> and either mail a copy to National Student Clearinghouse or provide a scanned copy in an e-mail attachment. Your order will be canceled if a consent form is not received within 30 days.
        </div>
      </nsc-card-content>
    </nsc-card>
  </div>

  <div *ngIf="show.paperConsentError">
    <nsc-spacer size="md"></nsc-spacer>
    <nsc-card class="nsc-card--error">
      <nsc-card-title-error title="Consent Is Required" icon="warning"></nsc-card-title-error>
      <nsc-card-content>
        <div class="mat-typography">
          Your order cannot be processed until your signed consent is received. Please refer to the Track Your Order link in your confirmation email for further instructions to complete your consent. This order will expire in 30 days if consent is not received.
        </div>
      </nsc-card-content>
    </nsc-card>
  </div>
  
  <nsc-spacer size="md"></nsc-spacer>

  <div class="nsc-form-actions">
    <button
      mat-raised-button
      id="orderconsent_cancel"
      class="nsc-form-actions__button"
      color="accent"
      type="button"
      (click)="cancel()">Cancel Order</button>
    <nsc-spacer horizontal="true" size="md"></nsc-spacer>
    <button
      mat-raised-button
      id="orderconsent_continue"
      class="nsc-form-actions__button nsc-form-actions__button--next"
      color="primary"
      type="button"
      (click)="continue()"
      [disabled]="!formGroup.valid && !values.enableContinueButton">Continue <mat-icon aria-hidden="true" *ngIf="formGroup.valid && values.enableContinueButton">chevron_right</mat-icon></button>
  </div>
</form>

<!-- <nsc-spacer size="md"></nsc-spacer>
<nsc-card>
  <nsc-card-title note="development mode only">Form Data Model</nsc-card-title>
  <nsc-card-content>
    <textarea class="json">{{ formGroup.value | json }}</textarea>
  </nsc-card-content>
</nsc-card> -->
